// Normalize pasted image URLs so they render as direct images.
// Dropbox share links (?dl=0) must be converted to a raw/direct link (?raw=1).
export const PRODUCT_PLACEHOLDER = "/marketplace-placeholder.jpg";

export function normalizeImageUrl(url) {
  if (!url) return url;
  let u = url.trim();
  if (u.includes("dropbox.com")) {
    u = u.replace(/([?&])dl=0/, "$1raw=1").replace(/([?&])dl=1/, "$1raw=1");
    if (!/[?&]raw=1/.test(u)) u += (u.includes("?") ? "&" : "?") + "raw=1";
  }
  return u;
}

// Returns a usable image src, falling back to the branded CBR placeholder.
export function productImage(url) {
  return url ? normalizeImageUrl(url) : PRODUCT_PLACEHOLDER;
}

